const Rtp = ({
  value,
}: {
  value: number | string | null | undefined;
}) => {
  if (value === null || value === undefined) {
    return null;
  }

  const numValue =
    typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numValue)) {
    return <>{value}</>;
  }

  const formattedValue = numValue.toFixed(2);

  return <>{formattedValue}%</>;
};

export default Rtp;
